import { useState, useEffect } from 'react';
import { makeGetCall } from '../utils/helper';

/**
 * Custom hook to fetch and cache registration type options
 * @returns {Object} { regTypeOptions, loading, error, refetch }
 */
export const useRegistrationTypes = () => {
  const [regTypeOptions, setRegTypeOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchRegistrationTypes = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await makeGetCall('/registration-types');
      
      if (response?.data?.success) {
        setRegTypeOptions(response.data.data || []);
      } else {
        throw new Error(response?.data?.message || 'Failed to fetch registration types');
      }
    } catch (err) {
      console.error('Error fetching registration types:', err);
      setError(err.message || 'Failed to fetch registration types');
      
      // Fallback to hardcoded options if API fails (aligned with hardcoded values)
      setRegTypeOptions([
        { label: 'IPD', value: 'I' },
        { label: 'OPD', value: 'O' }
      ]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRegistrationTypes();
  }, []);

  const refetch = () => {
    fetchRegistrationTypes();
  };

  return {
    regTypeOptions,
    loading,
    error,
    refetch
  };
};